import { useEffect, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import Logo from './Logo';
import { supabase } from '@/lib/supabase';

const navLinks = [
  { label: 'Trang chủ', to: '/' },
  { label: 'Thị trường', to: '/thi-truong' },
  { label: 'Lịch sử giá', to: '/lich-su-gia-vang' },
  { label: 'Giao dịch', to: '/giao-dich' },
  { label: 'Tài sản', to: '/tai-san' },
  { label: 'Chat hỗ trợ', to: '/chat-ho-tro' },
  { label: 'Hỗ trợ', to: '/lien-he' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [authed, setAuthed] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setAuthed(!!data.session);
      if (data.session) {
        supabase.rpc('is_admin_mgr').then(({ data: adminData }) => {
          setIsAdmin(!!adminData);
        }).catch(() => setIsAdmin(false));
      }
    });
    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setAuthed(!!session);
      if (session) {
        supabase.rpc('is_admin_mgr').then(({ data: adminData }) => {
          setIsAdmin(!!adminData);
        }).catch(() => setIsAdmin(false));
      } else {
        setIsAdmin(false);
      }
    });
    return () => {
      listener.subscription.unsubscribe();
    };
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setOpen(false);
    navigate('/');
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-background-50/90 backdrop-blur-md border-b border-background-200/60">
      <nav className="mx-auto flex items-center justify-between h-16 px-4 md:px-6">
        <Logo />

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              className={({ isActive }) =>
                `px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  isActive
                    ? 'text-primary-400 bg-primary-500/10'
                    : 'text-foreground-700 hover:text-primary-300 hover:bg-background-200/60'
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-2">
          {authed ? (
            <>
              {isAdmin && (
                <Link
                  to="/quan-tri/nguoi-dung"
                  className="px-4 py-2 rounded-md text-sm font-semibold text-accent-400 hover:text-accent-300 whitespace-nowrap cursor-pointer transition-colors"
                >
                  <i className="ri-shield-user-line mr-1"></i>Quản trị
                </Link>
              )}
              <Link
                to="/bang-dieu-khien"
                className="px-4 py-2 rounded-md text-sm font-semibold text-foreground-800 hover:text-primary-300 whitespace-nowrap cursor-pointer transition-colors"
              >
                Bảng điều khiển
              </Link>
              <button
                onClick={handleLogout}
                className="px-4 py-2 rounded-md text-sm font-semibold bg-primary-500 text-background-950 hover:bg-primary-600 whitespace-nowrap cursor-pointer transition-colors"
              >
                Đăng xuất
              </button>
            </>
          ) : (
            <>
              <Link
                to="/dang-nhap"
                className="px-4 py-2 rounded-md text-sm font-semibold text-foreground-800 hover:text-primary-300 whitespace-nowrap cursor-pointer transition-colors"
              >
                Đăng nhập
              </Link>
              <Link
                to="/dang-nhap"
                className="px-4 py-2 rounded-md text-sm font-semibold bg-primary-500 text-background-950 hover:bg-primary-600 whitespace-nowrap cursor-pointer transition-colors"
              >
                Đăng ký
              </Link>
            </>
          )}
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800 cursor-pointer"
          aria-label="Menu"
        >
          <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200/60 bg-background-50 px-4 py-4 flex flex-col gap-1">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `px-4 py-3 rounded-md text-sm font-medium whitespace-nowrap ${
                  isActive ? 'text-primary-400 bg-primary-500/10' : 'text-foreground-700 hover:text-primary-300'
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <div className="flex gap-2 mt-3">
            {authed ? (
              <>
                {isAdmin && (
                  <Link
                    to="/quan-tri/nguoi-dung"
                    onClick={() => setOpen(false)}
                    className="flex-1 text-center px-4 py-2.5 rounded-md text-sm font-semibold border border-accent-300 text-accent-400 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-shield-user-line mr-1"></i>Quản trị
                  </Link>
                )}
                <Link
                  to="/bang-dieu-khien"
                  onClick={() => setOpen(false)}
                  className="flex-1 text-center px-4 py-2.5 rounded-md text-sm font-semibold border border-background-300 text-foreground-800 whitespace-nowrap cursor-pointer"
                >
                  Bảng điều khiển
                </Link>
                <button
                  onClick={handleLogout}
                  className="flex-1 text-center px-4 py-2.5 rounded-md text-sm font-semibold bg-primary-500 text-background-950 whitespace-nowrap cursor-pointer"
                >
                  Đăng xuất
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/dang-nhap"
                  onClick={() => setOpen(false)}
                  className="flex-1 text-center px-4 py-2.5 rounded-md text-sm font-semibold border border-background-300 text-foreground-800 whitespace-nowrap cursor-pointer"
                >
                  Đăng nhập
                </Link>
                <Link
                  to="/dang-nhap"
                  onClick={() => setOpen(false)}
                  className="flex-1 text-center px-4 py-2.5 rounded-md text-sm font-semibold bg-primary-500 text-background-950 whitespace-nowrap cursor-pointer"
                >
                  Đăng ký
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}